import styled from "styled-components";

import color from "../../../../constants/color";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  border: 1px solid #ececec;
  border-radius: 8px;
  min-height: 270px;
`;

export const BackgroundImage = styled.img`
  width: 100%;
  min-height: 150px;
  max-height: 150px;
  border-radius: 8px;
`;

export const EffectContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin-top: -120px;
  padding-right: 32px;
`;

export const BackgroundEffect = styled.img`
  min-height: 100px;
  max-height: 100px;
`;

export const Title = styled.p`
  min-height: 100px;
  max-height: 100px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: #000000;
  margin: -100px 0 0 32px;
`;

export const ContainerSwipe = styled.div`
  min-height: 160px;
  margin-top: -40px;
  padding: 0 12px 16px 12px;

  .rec-slider-container {
    min-height: 130px;
  }
`;

export const ShortcutCard = styled.a`
  background: ${color.White};
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.2);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  height: 130px;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 218px;
  margin: 0 0 16px 0;
`;

export const CardText = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.01em;
  color: ${color.grey1};
  margin-top: 24px;
`;

export const BlankIcon = styled.span`
  position: absolute;
  right: 16px;
  top: 16px;
`;
